import { render, staticRenderFns } from "./ComplexSelectie.vue?vue&type=template&id=79a39a34"
import script from "./ComplexSelectie.vue?vue&type=script&lang=js"
export * from "./ComplexSelectie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports